import { GetJSON } from '../apiUtils';

export type AiredaleCategory = {
  articlevoucherretailercategory?: string;
  canonical: string;
  thumbnail?: string;
  id: string;
  articleauthor: string[];
  articleauthorurl?: string[];
  createddate: string;
};

type AiredaleResponse = AiredaleCategory[];

type AiredaleFeedsParams = {
  site?: string;
  length?: number;
  retailerCategory?: string;
  territory?: string;
  fields?: string;
  articleId?: string;
};

export const createAiredaleFeedsGetter = (getJSON: GetJSON<AiredaleResponse>) => {
  return async (params: AiredaleFeedsParams): Promise<AiredaleResponse> => {
    const {
      site,
      length = 100,
      retailerCategory,
      territory,
      fields = 'articlevoucherretailercategory,canonical',
      articleId,
    } = params;

    const airedaleEndpoint = process.env.AIREDALE_ENDPOINT;
    if (!airedaleEndpoint) {
      throw new Error('AIREDALE_ENDPOINT environment variable is not defined');
    }

    const response = await getJSON(airedaleEndpoint, {
      site,
      nb_results: length,
      fl: fields,
      articleTerritory: territory,
      articleVoucherRetailerCategory: retailerCategory,
      articleId,
    });

    if (!response.ok) {
      throw new Error("Couldn't fetch Airedale feeds");
    }
    return response.data.map((airedaleCategory) => ({
      ...airedaleCategory,
      // Airedale returns string "null" when a thumbnail is missing
      thumbnail: airedaleCategory.thumbnail === 'null' ? undefined : airedaleCategory.thumbnail,
    }));
  };
};

export type AiredaleFeedsGetter = ReturnType<typeof createAiredaleFeedsGetter>;
